import React, { lazy, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import DashboardLayout from "../components/layout/DashboardLayout";
import NotFoundPage from "../components/common/NotFoundPage/NotFoundPage";
import ProtectedRoute from "../components/common/ProtectedRoute";
// import { useSelector } from "react-redux";

// Auth
const LoginPage = lazy(() => import("../pages/auth/LoginPage"));

// Dashboard
const DashboardPage = lazy(() => import("../pages/dashboard/Dashboard"));

// Production
const ProductsListV1 = lazy(() => import("../pages/inventory/ProductsListV1"));
const ColorsListV1 = lazy(() => import("../pages/inventory/ColorsListV1"));

// Stocks
const HoldingStocksV1 = lazy(
	() => import("../pages/inventory/HoldingStocksV1"),
);

// Orders
const OrdersPageNew = lazy(
	() => import("../pages/orders/ordersPage/components/OrdersPage"),
);
const OrdersTracker = lazy(() => import("../pages/orders/ordersTracker"));

// Assign to Warehouse
const AssignWarehousePage = lazy(
	() => import("../pages/orders/assignOrderToWarehouse/AssignWarehousePage"),
);

// Assignments
const ViewAssignmentPage = lazy(
	() => import("../pages/assignments/ViewAssignmentPage"),
);
const AssignmentsPage = lazy(
	() => import("../pages/assignments/AssignmentsPage"),
);
// Payments
// const PaymentsTrackerPage = lazy(
// 	() => import("../pages/payments/payments-tracker"),
// );  /////////////// This is V0 - moving to v1
const PaymentsTrackerPage = lazy(
	() => import("../pages/payments/payments-tracker/PaymentsTrackerPage"),
);

// Warehouse
// const WarehouseAssignmentsPage = lazy(
// 	() =>
// 		import("../oldCodeBackup/Dashboard/WarehouseAssignments/WarehouseAssignmentsPage"),
// );
const ViewCourier = lazy(() => import("../components/common/ViewCourier"));
const WarehouseAssignmentsPageV2 = lazy(
	() =>
		import("../pages/warehouse/warehouseManageAssignments/WarehouseAssignmentsPage"),
);

// Utilities
const XlsxImportExport = lazy(
	() => import("../pages/utilities/XlsxImportExport"),
);

const AppRoutes = () => {
	// Get logged-in user from Redux store (adjust selector as needed)
	// const CURRENT_USER = useSelector((state) => state?.auth?.user?.displayName);
	const CURRENT_USER =
		JSON.parse(localStorage.getItem("auth_user"))?.displayName || "Unknown";
	console.log("App Routes, ", CURRENT_USER);

	return (
		<Suspense fallback={<div className="page-loader">Loading...</div>}>
			<Routes>
				{/* Public */}
				<Route path="/login" element={<LoginPage />} />

				{/* Protected — ProtectedRoute guards all children, DashboardLayout is the shell */}
				<Route element={<ProtectedRoute />}>
					<Route element={<DashboardLayout />}>
						<Route
							index
							element={<Navigate to="/dashboard" replace />}
						/>
						{/* Dashboard */}
						<Route path="/dashboard" element={<DashboardPage />} />

						{/* Production */}
						<Route
							path="production/products"
							element={<ProductsListV1 />}
						/>
						<Route
							path="production/colors"
							element={<ColorsListV1 />}
						/>

						{/* Stocks */}
						<Route
							path="stocks/holdingv1"
							element={<HoldingStocksV1 />}
						/>

						{/* Orders */}
						<Route
							path="/orders/manage"
							element={<OrdersPageNew />}
						/>
						<Route
							path="/orders/manage/:orderId"
							element={<OrdersPageNew />}
						/>
						<Route path="/orders" element={<OrdersTracker />} />

						{/* Assign to Warehouse */}
						<Route
							path="/assigned/assign/:orderId"
							element={<AssignWarehousePage />}
						/>
						{/* Assignments */}
						<Route
							path="/assignments"
							element={<AssignmentsPage />}
						/>
						<Route
							path="/assigned/view-assignment/:assignmentId"
							element={<ViewAssignmentPage />}
						/>
						{/* Payments */}
						<Route
							path="/payments"
							element={<PaymentsTrackerPage />}
						/>

						{/* Warehouse */}
						{/* <Route
						path="/assigned/warehouse-pov-v0"
						element={<WarehouseAssignmentsPage />}
					/> */}
						<Route
							path="/assigned/view-courier/:courierId"
							element={<ViewCourier />}
						/>
						<Route
							path="/assigned/warehouse-pov/:assignmentId?"
							element={
								<WarehouseAssignmentsPageV2
									currentUser={CURRENT_USER}
								/>
							}
						/>

						{/* Utilities */}
						<Route
							path="data/import-export"
							element={<XlsxImportExport />}
						/>
					</Route>
				</Route>

				{/* 404 */}
				<Route path="*" element={<NotFoundPage />} />
			</Routes>
		</Suspense>
	);
};

export default AppRoutes;
